// frontend/src/pages/LoginPage.jsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../services/api";

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError]       = useState("");
  const [loading, setLoading]   = useState(false);
  const navigate                = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const res = await login(username, password);
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user",  JSON.stringify(res.data.user));
      // Everyone goes to dashboard first
      navigate("/dashboard");
    } catch (err) {
      setError(err.response?.data?.message || "Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight:"100vh", background:"#0a0f1a", display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'JetBrains Mono',monospace", padding:16 }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;600;700&family=Syne:wght@700;800&display=swap');
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.5} }
      `}</style>
      <div style={{ background:"#0d1520", border:"1px solid #1a2e1a", borderRadius:20, padding:"40px 32px", width:"100%", maxWidth:360, boxShadow:"0 25px 50px rgba(0,0,0,0.5)" }}>

        {/* Logo */}
        <div style={{ textAlign:"center", marginBottom:28 }}>
          <div style={{ fontSize:40, marginBottom:8 }}>⚡</div>
          <div style={{ fontFamily:"'Syne',sans-serif", fontSize:24, fontWeight:800, color:"#4ade80" }}>CEB Solar Poles</div>
          <div style={{ fontSize:10, color:"#4b5563", letterSpacing:"0.15em", marginTop:4 }}>FIELD SUPERVISORY SYSTEM</div>
        </div>

        {error && (
          <div style={{ background:"#450a0a", border:"1px solid #7f1d1d", borderRadius:10, padding:"10px 14px", color:"#fca5a5", fontSize:12, marginBottom:16 }}>
            ❌ {error}
          </div>
        )}

        <div style={{ marginBottom:14 }}>
          <label style={{ fontSize:10, color:"#64748b", display:"block", marginBottom:5, letterSpacing:"0.1em" }}>USERNAME</label>
          <input value={username} onChange={e=>setUsername(e.target.value)}
            onKeyDown={e => e.key === "Enter" && handleSubmit(e)}
            style={{ width:"100%", background:"#0a1628", border:"1px solid #1e3a2e", borderRadius:10, padding:"11px 14px", color:"#e2e8f0", fontSize:14, outline:"none", boxSizing:"border-box" }} />
        </div>
        <div style={{ marginBottom:22 }}>
          <label style={{ fontSize:10, color:"#64748b", display:"block", marginBottom:5, letterSpacing:"0.1em" }}>PASSWORD</label>
          <input type="password" value={password} onChange={e=>setPassword(e.target.value)}
            onKeyDown={e => e.key === "Enter" && handleSubmit(e)}
            style={{ width:"100%", background:"#0a1628", border:"1px solid #1e3a2e", borderRadius:10, padding:"11px 14px", color:"#e2e8f0", fontSize:14, outline:"none", boxSizing:"border-box" }} />
        </div>
        <button onClick={handleSubmit} disabled={loading}
          style={{ width:"100%", background: loading ? "#166534" : "linear-gradient(135deg,#16a34a,#15803d)", color:"#fff", border:"none", borderRadius:10, padding:"13px", fontSize:14, fontWeight:700, cursor: loading ? "not-allowed" : "pointer", letterSpacing:"0.05em" }}>
          {loading ? "⏳ Signing in..." : "Sign In →"}
        </button>

        <div style={{ marginTop:16, fontSize:11, color:"#374151", textAlign:"center" }}>
          Ceylon Electricity Board · Solar Pole Tracker v2.0
        </div>
      </div>
    </div>
  );
}
